export default __webpack_public_path__ + "static/media/capture-stones.24a0758b.md";